import {gql} from '@apollo/client/core';

export const VismaOrderDetails = gql`
  fragment vismaOrderDetail on VismaOrderDetail {
    id
    lines {
      id
      title
      quantity
      unitPriceWithVat
      totalWithVat
    }
  }
`;
